// extracted by extract-css-chunks-webpack-plugin
module.exports = {"xs":"667.98","sm":"947.98","md":"1023.98","lg":"1229.98","container":"Gh10rlOp","content":"TAxZlmEf","heading":"rQqp9795"};